import { render, staticRenderFns } from "./addGuide.vue?vue&type=template&id=c8be5322&scoped=true&"
import script from "./addGuide.vue?vue&type=script&lang=js&"
export * from "./addGuide.vue?vue&type=script&lang=js&"
import style0 from "./addGuide.vue?vue&type=style&index=0&id=c8be5322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8be5322",
  null
  
)

export default component.exports